import styled, { css } from "styled-components";
import { focusStyle } from "../../../../../shared-components/toyota/styles/utils/Accessibility.styles";
import { breakpoints } from "../../../../../shared-logic/themes/toyotaTheme";

export const Wrapper = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    flex-grow: 1;
`;

export const Bottom = styled.div`
    display: flex;
    position: sticky;
    flex-direction: column;
    z-index: 10;

    &:not(:empty) {
        bottom: var(--spacing-5);
        row-gap: calc(var(--spacing-3) / 2);
        margin-top: auto;
        padding-block-start: var(--spacing-4);
        background-color: var(--color-primary-white);

        @supports not (padding-block-start: 0) {
            padding-top: var(--spacing-4);
        }
    }

    @media screen and (min-width: ${breakpoints.xl}) {
        /* Styles for a line at the top of the sticky bottom section */
        &:not(:empty)::before {
            display: block;
            position: absolute;
            top: 0;
            left: calc(var(--spacing-5) * -1);
            width: 100vw;
            height: 1px;
            content: "";
            background-color: var(--color-grey-4);
        }

        &:not(:empty)::after {
            display: block;
            position: absolute;
            top: -40px;
            width: 100%;
            height: 40px;
            content: "";
            background: linear-gradient(180deg, rgb(255 255 255 / 0) 0%, var(--color-primary-white) 100%);
        }
    }
`;

export const Top = styled.div`
    display: flex;
    position: sticky;
    top: var(--visibleHeaderHeight, 0);
    flex-direction: column;
    flex-grow: 0;
    padding-bottom: var(--spacing-7);
    overflow-y: hidden;

    @media screen and (min-width: ${breakpoints.xl}) {
        padding-block-start: var(--spacing-2);
    }

    @supports not (padding-block: 0) {
        top: 0;
        padding-top: var(--spacing-2);
    }
`;

export const Scrollable = styled.div`
    --sticky-top-spacing: 16px;
    --basket-bottom-spacing: 32px;
    max-height: calc(
        100vh - var(--visibleHeaderHeight) - (var(--basket-bottom-height) + var(--basket-bottom-spacing)) -
            (var(--basket-sticky-top-height) + var(--sticky-top-spacing))
    );
    padding-block: var(--spacing-3);
    overflow-y: auto;

    & > div {
        display: flex;
        flex-direction: column;
        row-gap: var(--spacing-3);
        padding-bottom: var(--spacing-5);

        @supports not (row-gap: 0) {
            & > div:not(:nth-last-child(1)) {
                margin-bottom: var(--spacing-3);
            }
        }
    }

    @supports not (padding-block: 0) {
        padding-top: var(--spacing-3);
        padding-bottom: var(--spacing-3);
    }
`;

export const VehicleInformationDesktopWrapper = styled.div`
    display: none;
    @media screen and (min-width: ${breakpoints.md}) {
        display: block;
    }
`;

export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    column-gap: var(--spacing-2);
    margin-top: auto;
`;

export const Button = styled.button<{ iconRight?: boolean }>`
    display: flex;
    flex: 1 0 50%;
    align-items: center;
    justify-content: center;
    column-gap: var(--spacing-1);
    padding: var(--spacing-1);
    font-family: var(--font-regular);
    font-size: 1.3rem;
    line-height: 2rem;
    color: var(--color-primary-black);
    border: 1px solid var(--color-grey-4);
    border-radius: 3px;

    span:not(.dxp-icon) {
        flex-grow: 1;
    }

    ${({ iconRight }) =>
        iconRight &&
        css`
            flex-direction: row-reverse;
        `};

    &:is(:hover, :focus) {
        border-color: var(--color-primary-black);
    }

    &[disabled] {
        color: var(--color-grey-7);
        border-color: var(--color-grey-4);
    }

    ${focusStyle};
`;

export const InlineTextIcon = styled.div`
    display: flex;
    align-items: center;
    column-gap: var(--spacing-1);
`;

export const QrCodewrapper = styled.div`
    margin-top: var(--spacing-1);
`;
